export default __webpack_public_path__ + "static/media/goals.3e5b20d0.png";